import React, { useState } from 'react';
import axios from 'axios';
import { header } from '../components/header.encry';
import { generateBarcodeFromValue } from '../components/barcodeHelper';
import { formatOrderTicketDateTime } from '../utils/orderTicket';
import { toast } from 'react-toastify';

function TicketByAmount() {
  const [amount, setAmount] = useState('');
  const roles = JSON.parse(sessionStorage.getItem('roles') || '[]');
  const isAllowed = roles.includes('carrefour') || roles.includes('admin') || roles.includes('manager');

  const handleGenerate = async () => {

    const raw = parseInt(amount, 10);
    if (!raw || raw <= 0) return;
    const value = Math.floor(raw * 0.7);
    if (value <= 0) return;

    try {
      const { data } = await axios.get(`${process.env.REACT_APP_PEGASUS_API_URL}/dolibarr/ticket/${value}`, header());
      const ticketLines = (data.items || []).map((item) => ({
        description: item.name || item.barcode,


        price: item.price * item.qty,
        quantity: item.qty,
        barcodeSvg: generateBarcodeFromValue(item.barcode),
      }));
      const total = data.total || ticketLines.reduce((sum, l) => sum + l.price, 0);
      const orderDateTime = formatOrderTicketDateTime();
      localStorage.setItem('orderTicket', JSON.stringify({ storeName: 'Ticket', lines: ticketLines, total, orderDateTime }));
      window.open('/order-ticket', '_blank');
    } catch (e) {
      toast.error('Erreur lors de la génération du ticket');
    }
  };

  if (!isAllowed) {
    return <div className='container mt-4'>Accès refusé</div>;
  }

  return (
    <div className='container mt-4'>
      <h2>Ticket par montant</h2>
      <div className='mb-3'>
        <label className='form-label me-2'>Montant</label>
        <input type='number' className='form-control d-inline-block w-auto me-2' value={amount} onChange={e => setAmount(e.target.value)} min='1' />
        <button className='btn btn-primary' onClick={handleGenerate}>Générer</button>
      </div>
    </div>
  );
}

export default TicketByAmount;
